import Upsertable from '@/models/Upsertable'
import { useAgriProductAgriApplicationStore } from '@/stores/agriProductAgriApplicationStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class AgriProductAgriApplication extends Upsertable {
  static store() {
    return useAgriProductAgriApplicationStore()
  }

  store() {
    return AgriProductAgriApplication.store()
  }

  static find(uuid) {
    const store = AgriProductAgriApplication.store();
    return store.collection.find(item => item.uuid === uuid);
  }
  
  static find_products_by_application_uuid(application_uuid) {
    return AgriProductAgriApplication.store()
      .all()
      .filter((agri_product_agri_application) => agri_product_agri_application.agri_application_uuid == application_uuid)
  }
}

useModelName(AgriProductAgriApplication, "AgriProductAgriApplication")
ModelRegistry.register(AgriProductAgriApplication, "AgriProductAgriApplication")